<template>
  <v-container fluid v-editable="blok" class=" pa-0" v-if="blog">
    <v-sheet
      class="banner-container"
      :style="`background-image: url('${blok.bannerImage}');`"
      tile
      height="400"
    >
      <div class="bg"></div>
      <v-container fluid v-editable="blok" class=" fill-height">
        <v-row justify="start" align="start">
          <v-col cols="12" class="text-left">
            <div class="title mb-5">
              <div class="pb-icon">
                <div class="before">
                  <span>◄</span>
                </div>
                <figure>
                  <img src="@/assets/logo_mini.svg" alt />
                </figure>
              </div>
              <h2>{{blog.title}}</h2>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
    <!--BLOG CONTENT-->
    <v-container v-editable="blok" class=" fill-height">
      <v-row justify="start" align="start">
        <v-col cols="12" class="text-left">
          <v-row justify="space-between" align="center">
            <v-col cols="12" sm="6" class="cadate text-center text-sm-left">
              <p>{{blog.category}}</p>
              <p>{{blog.date}}</p>
            </v-col>
            <v-col cols="12" sm="6" class="text-center text-sm-right share">
              <p>Compartir publicación</p>
              <v-btn class="ma-2" tile color="#021041" icon target="_blank" :href="`https://www.facebook.com/sharer/sharer.php?u=${url}`">
                <v-icon>mdi-facebook</v-icon>
              </v-btn>
              <v-btn class="ma-2" tile color="#021041" icon target="_blank" :href="`https://twitter.com/intent/tweet?text=${blog.title} en ${url}`">
                <v-icon>mdi-twitter</v-icon>
              </v-btn>
              <v-btn class="ma-2" tile color="#021041" icon target="_blank" :href="`https://www.linkedin.com/shareArticle?&url=${url}`">
                <v-icon>mdi-linkedin</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="text-left">
          <v-card tile color="#021041" class="pa-5 text-center shortDescription">
            <h4>{{blog.shortDescription}}</h4>
          </v-card>
        </v-col>
        <v-col cols="12" class="text-left content-blog">
          <vue-markdown>{{blog.content}}</vue-markdown>
        </v-col>
      </v-row>
    </v-container>
    <!--/BLOG CONTENT-->
    <!--RELATED -->

      <v-container class="related mb-5 pb-5">
        <v-row justify="center" v-if="story">
          <v-col cols="12">
            <div class="title mb-5">
              <h2>{{blok.relatedTitle}}</h2>
              <div class="pb-icon">
                <figure>
                  <img src="@/assets/logo_mini_dark.svg" alt />
                </figure>
                <div class="after"></div>
              </div>
            </div>
          </v-col>

          <v-col cols="12" sm="6" md="6" class="d-flex" v-for="(item, index) in story" :key="index">
            <v-card class="text-left card pa-5" tile :to="`/${item.full_slug}`">
              <em>{{item.content.category}}</em>
              <h4>{{item.content.title}}</h4>
              <em>{{item.content.date}}</em>
              <p>{{item.content.shortDescription}}</p>
            </v-card>
          </v-col>
        </v-row>
        <!-- /RELATED -->
      </v-container>
  </v-container>
</template>

<script>
import VueMarkdown from "vue-markdown";
// 1. Require the Storyblok client
import StoryblokClient from "storyblok-js-client";

// 2. Set your token
const token = "vNbkVTgCgnArqEk6TG7LQwtt";

// 3. Initialize the client with the preview token so we can access our API easily
// from your space dashboard at https://app.storyblok.com
let storyapi = new StoryblokClient({
  accessToken: token
});

export default {
  name: "BlogDetail",
  components: {
    "vue-markdown": VueMarkdown
  },
  props: ["blok"],
  data() {
    return {
      msg: "",
      story: null,
      blog: null,
      url: null
    };
  },
  mounted() {
    this.url = window.location.href;
    // 4. Initialize the Storyblok Client Bridge to allow us to subscribe to events
    // from the editor itself.
    window.storyblok.init({
      accessToken: token
    });
    window.storyblok.on("change", () => {
      this.getBlog("draft");
    });
    window.storyblok.pingEditor(() => {
      if (window.storyblok.isInEditor()) {
        // draft will be loaded if embeded in app.storyblok.com
        this.getBlog("draft");
      } else {
        // published versions will be loaded outside of app.storyblok.com
        // so make sure to published your entries - otherwise this will be a 404
        this.getBlog("published");
      }
    });
  },
  methods: {
    getBlog(version) {
      storyapi
        .get(
          `cdn/stories/${this.blok.lenguage}/blog-articles/${this.$route.params.name}`,
          {
            version: version
          }
        )
        .then(response => {
          if (response) {
            this.blog = response.data.story.content;
            window.storyblok.pingEditor(() => {
              if (window.storyblok.isInEditor()) {
                // draft will be loaded if embeded in app.storyblok.com
                this.getRelatedBlogs(
                  `${this.blok.lenguage}/blog-articles`,
                  "draft",
                  response.data.story.content.category,
                  response.data.story.content._uid
                );
              } else {
                // published versions will be loaded outside of app.storyblok.com
                // so make sure to published your entries - otherwise this will be a 404
                this.getRelatedBlogs(
                  `${this.blok.lenguage}/blog-articles`,
                  "published",
                  response.data.story.content.category,
                  response.data.story.content._uid
                );
              }
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getRelatedBlogs(slug, version, category, id) {
      storyapi
        .get("cdn/stories/", {
          version: version,
          starts_with: slug,
          sort_by: "created_at:asc",
          filter_query: {
            _uid: {
              not_in: id
            },
            category: {
              in: category
            }
          },
          page: 1,
          per_page: 2
        })
        .then(response => {
          this.story = response.data.stories;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./BlogDetail.scss";
</style>